import { Link as ChakraLink, LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { primaryThemeGradient } from 'constants/theme';

type LinkProps = ChakraLinkProps & {
  to?: string;
};

const LinkStyles: ComponentStyleConfig = {
  baseStyle: {
    textDecoration: 'underline',
    fontSize: 'md',
    lineHeight: 1,
    _hover: {
      textDecoration: 'underline',
    },
    _focus: {
      boxShadow: 'none',
    },
    color: 'primaryThemeColour.400',
  },
  variants: {
    button: {
      display: 'inline-flex',
      px: 2.5,
      py: 3.5,
      borderStyle: 'solid',
      alignSelf: 'center',
      color: 'primaryFontColour.400',
      fontWeight: 'normal',
      fontStretch: 'expanded',
      letterSpacing: 3,
      fontSize: 'sm',
      _hover: {
        textDecoration: 'none',
      },
      border: 'none',
      justifyContent: 'center',
      cursor: 'pointer',
      height: 'auto',
      borderRadius: 6,
      textDecoration: 'none',
      bg: primaryThemeGradient,
    },
  },
};

const Link = ({ children, to = '', ...props }: LinkProps) => {
  const reactRouterProps =
    to !== ''
      ? {
          as: RouterLink,
        }
      : {};

  return (
    <ChakraLink to={to} {...reactRouterProps} {...props}>
      {children}
    </ChakraLink>
  );
};

export { Link, LinkStyles };
